import { draftShift } from './adm';
import {FIRST,LAST,PREF,RESS,RID,RMAP,RTOT,SCANDALS,TAGS} from '../content/ressorts';
import {OUTLETS} from '../content/parties';
import {DI,on} from '../content/settings';
import {coalSeats} from './election';
import {toast} from './govern';
import {press} from './media';
import {choice,rnd} from './rng';
import {PA,PN,score} from './rules';
import {S,log} from './state';
import { since } from './version';
import {clamp} from './util';



RESS.forEach((r:any)=>r.r.forEach((x:any)=>RMAP[x]=r.id));







export const ri:any=(a:any,b:any)=>a+Math.floor(rnd()*(b-a+1));

export function genMin(p?:any,type?:any){
  const used=new Set(Object.values<any>(S.min||{}).map((m:any)=>m.n));let n,g=0;do{n=choice(FIRST)+' '+choice(LAST)}while(used.has(n)&&g++<50);
  let k,l,r;
  if(type==='expert'){k=ri(4,5);l=ri(2,3);r=choice([0,1,2])}
  else if(type==='loyal'){k=ri(2,3);l=5;r=choice([0,0,1])}
  else if(type==='star'){k=ri(3,5);l=ri(3,4);r=2}
  else{k=choice([2,3,3,3,4,4,5]);l=p==='YOU'?choice([3,3,4,4,5]):choice([2,3,3,4,4]);r=choice([0,0,0,1,1,2])}
  return{n,p,k,l,r,tag:TAGS[type]||'',since:S.m}
}
export function defaultRess(){
  const out:any={fin:'YOU'};if(!S.partners.length){RESS.forEach((r:any)=>out[r.id]='YOU');return out}
  const parties=['YOU',...S.partners],tot=coalSeats(),want:any={},have:any={};
  parties.forEach((p:any)=>{want[p]=RTOT*S.res.seats[p]/tot;have[p]=0});have.YOU=RID.fin.w;
  RESS.filter((r:any)=>r.id!=='fin').sort((a:any,b:any)=>b.w-a.w).forEach((r:any)=>{let best='YOU',bv=-1e9;
    parties.forEach((p:any)=>{const v=want[p]-have[p]+(p!=='YOU'&&(PREF[p]||[]).includes(r.id)?1.2:0);if(v>bv){bv=v;best=p}});
    out[r.id]=best;have[best]+=r.w});
  return out;
}
export function ressBonus(p?:any,R?:any){R=R||S.ress||{};
  const share=RESS.reduce((s:any,r:any)=>s+(R[r.id]===p?r.w:0),0)/RTOT,exp=S.res.seats[p]/coalSeats();
  return clamp((share-exp)*.6,-.15,.06)+(PREF[p]||[]).filter((id:string)=>R[id]===p).length*.02}
export function formCabinet(){
  const old=S.min||{};S.min={};
  RESS.forEach((r:any)=>{const p=S.ress[r.id];S.min[r.id]=(old[r.id]&&old[r.id].p===p)?old[r.id]:genMin(p)});
  S.fin=S.ress.fin;
}
export function draftInfo(T?:any,fx?:any){
  const rid=RMAP[T.r]||'as',M=S.min&&S.min[rid];if(!M)return{months:fx.months,q:1,delay:0,M:null,rid};
  let months=Math.max(1,fx.months+[2,1,0,-1,-1][M.k-1]+draftShift(rid)),delay=0;
  if(M.p!=='YOU'&&score(M.p,fx.pos)<.5){delay=2;months+=2}
  return{months,q:.8+M.k*.067,delay,M,rid}
}
export function candidates(p?:any){return['expert','loyal','star'].map((t:any)=>genMin(p,t))}
export function appoint(i?:any){
  const P=S.pickFor,M=P.c[i];M.since=S.m;S.min[P.rid]=M;S.pickFor=null;
  if(P.why==='umbildung'){S.basis-=.3;press(OUTLETS[0].n,`Kabinettsumbildung: ${M.n} übernimmt ${RID[P.rid].n}`,M.k>=4?.3:0);log(`Kabinettsumbildung: ${M.n} wird neu für ${RID[P.rid].n} zuständig.`)}
  else log(`${M.n} übernimmt das Ressort ${RID[P.rid].n}.`,'good');
}
export function ministerEvents(){
  if(!S.min||S.scandal||S.pickFor)return false;
  // Feste Reihenfolge der Ressorts, nicht die Schlüsselreihenfolge des Objekts: Ein aus der Cloud geladener
  // Spielstand (Postgres jsonb) hat die Schlüssel umsortiert, der Zufall träfe sonst andere Minister.
  const ORD=RESS.map((r:any)=>r.id).filter((id:string)=>S.min[id]);
  for(const rid of ORD){const M=S.min[rid];
    if(on('scandal')&&rnd()<[.002,.006,.014][M.r]*[.5,1,1.5][DI()]){
      const t=choice(SCANDALS);S.scandal={rid,t,m:S.m};S.scandalsLeg=(S.scandalsLeg||0)+1;if(since(12))(S as any).scM=S.m; // Version 12: Untersuchungsausschuss im Spiel zu zweit
      log(`Affäre um ${M.n} (${RID[rid].n}, ${PA(M.p)}): ${t}.`,'bad');
      press(choice(OUTLETS).n,`${M.n} unter Druck: ${t}`,-1);toast(`Affäre um ${M.n}`,'bad');return true}}
  for(const rid of ORD){const M=S.min[rid];
    if(rnd()<(5-M.l)*.003){
      if(M.p==='YOU'){S.basis-=.3;press(OUTLETS[0].n,`${M.n} widerspricht öffentlich dem Kanzleramt`,-.6);log(`${M.n} (${RID[rid].n}) kritisiert öffentlich den Regierungskurs.`,'bad')}
      else{S.coal=clamp(S.coal-3,0,100);press(OUTLETS[0].n,`${PA(M.p)}-Ministerium stellt sich gegen das Kanzleramt`,-.6);log(`${M.n} (${PA(M.p)}, ${RID[rid].n}) stellt sich öffentlich gegen euch.`,'bad')}
      break}}
  return false;
}
export function resign(rid?:any,forced?:any){
  const M=S.min[rid];
  if(M.p==='YOU'){S.pickFor={rid,why:'skandal',c:candidates('YOU')}}
  else{const n=genMin(M.p);S.min[rid]=n;S.coal=clamp(S.coal-2,0,100);log(`${PN(M.p)} benennt ${n.n} als Nachfolge für ${RID[rid].n}.`)}
  if(forced){press(OUTLETS[0].n,`Zu spät: ${M.n} muss doch zurücktreten`,-2.5);S.basis-=1.5}
  else press(OUTLETS[0].n,`Rücktritt: ${M.n} zieht die Konsequenzen`,-.3);
  log(`${M.n} tritt zurück.`,forced?'bad':'');
}
export function scandalDecide(fire?:any){
  const sc=S.scandal,M=S.min[sc.rid];S.scandal=null;
  if(fire)resign(sc.rid,false);
  else{S.basis-=.5;press(OUTLETS[2].n,`Regierung hält an ${M.n} fest, Opposition fordert Rücktritt`,-1.2);S.linger={rid:sc.rid,until:S.m+3,n:M.n};log(`Ihr haltet an ${M.n} fest.`)}
}
export function lingerTick(){
  const L=S.linger;if(!L)return false;const M=S.min[L.rid];
  if(!M||M.n!==L.n){S.linger=null;return false}
  if(rnd()<.3){S.linger=null;log(`Neue Enthüllungen: Die Affäre um ${M.n} eskaliert.`,'bad');resign(L.rid,true);toast(`${M.n} muss zurücktreten`,'bad');return true}
  if(S.m>=L.until){S.linger=null;M.l=Math.min(5,M.l+1);log(`Die Affäre um ${M.n} ebbt ab. ${M.n} ist euch nun besonders verbunden.`,'good')}
  return false;
}
